import type { DeliveryAddress } from '@/delivery-address/entities'
import type { GoogleAddress } from '@/user/address-book/entities'

export const mapGoogleAddressToDeliveryAddress = (address: GoogleAddress) => {
  const deliveryAddress: DeliveryAddress = {
    latitude: address.latitude!,
    longitude: address.longitude!,
    cityCode: address.cityCode!,
    countryCode: address.countryCode!,
    cityName: address.addressComponents.locality! ?? '',
    text: address.title,
    details: '',
    placeId: address.placeId,
    isVerified: false,
  }
  return deliveryAddress
}
